import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { VerificationEvents } from 'shared/constants/datalayer';
import { useNewVerificationPanelFlag } from 'shared/featureFlags';
import { VerificationMethodContainer } from './VerificationMethod';
import { VerificationMethodV2 } from './VerificationMethodV2';

const ABTestVerification: React.FC = () => {
	const history = useHistory();

	useEffect(() => {
		VerificationEvents.OPEN({
			current_page: (history?.location?.state as string) ?? '',
		});
	}, []);
	const newVerificationPanelFlag = useNewVerificationPanelFlag();

	return newVerificationPanelFlag?.value ? <VerificationMethodV2 /> : <VerificationMethodContainer />;
};

export default ABTestVerification;
